import { Modal, Typography } from 'antd'
import { useSelector } from 'react-redux';
import { UpdateForm } from './UpdateForm.component';
import { AddForm } from './AddForm.component';
import { selectAllTemplatesData } from '@store/template';

interface Props {
  visible: boolean;
  onCancel: () => void;
}

export const AddUpdateForm = ({ visible, onCancel }: Props) => {
  const { selectedTemplate } = useSelector(selectAllTemplatesData);

  return (
    <Modal
      className='users-actions_modal'
      title={(
        <Typography.Text className='flex justify-center text-base font-bold'>
          {`${selectedTemplate ? `Edit - ${selectedTemplate.title}` : 'Add new template'}`}
        </Typography.Text>
      )}
      centered
      visible={visible}
      onCancel={onCancel}
      footer={false}
      width={800}
    >
      {selectedTemplate?.id
        ? <UpdateForm onCancel={onCancel} />
        : <AddForm onCancel={onCancel} />}
    </Modal>
  )
}
